import { render, staticRenderFns } from "./navPagePluginSelectOrg.vue?vue&type=template&id=4ddfdba3&scoped=true"
import script from "./navPagePluginSelectOrg.vue?vue&type=script&lang=js"
export * from "./navPagePluginSelectOrg.vue?vue&type=script&lang=js"
import style0 from "./navPagePluginSelectOrg.vue?vue&type=style&index=0&id=4ddfdba3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ddfdba3",
  null
  
)

export default component.exports